import FormattedMessage from 'I18n/components/FormattedMessage';
import { getGenericChannel } from 'find-and-filter-data/search-and-filter-schema/protected';
import UISelect from 'UIComponents/input/UISelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { useFilterValues } from 'find-and-filter-data/search-and-filter-data/public';
import { useSelector } from 'react-redux';
import { useGenericChannels } from 'conversations-thread-data/generic-channels/public/hooks';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { isLoading } from 'conversations-async-data/async-data/operators/statusComparators';
import { jsx as _jsx } from "react/jsx-runtime";
const buildOption = genericChannel => {
  return {
    text: genericChannel.displayName,
    value: genericChannel.genericChannel.id
  };
};
const ChannelFilter = () => {
  const inboxId = useSelector(getCurrentInboxId);

  //Get the generic channels for the current inbox
  const {
    asyncGenericChannels
  } = useGenericChannels({
    inboxId: inboxId
  });
  const genericChannels = getData(asyncGenericChannels);
  const loadingGenericChannels = isLoading(asyncGenericChannels);
  const {
    filterValues,
    setFilterValue
  } = useFilterValues();
  const placeholder = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.genericChannel.placeholder"
  });
  const onChange = e => {
    const {
      value
    } = e.target;
    if (value) {
      setFilterValue('genericChannel', [value]);
      setFilterValue('channelInstanceId', null);
    } else setFilterValue('genericChannel', null);
  };
  const genericChannel = getGenericChannel(filterValues);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.thread-search-and-filtering.filter-sidebar.filter-options.genericChannel.title"
    }),
    children: /*#__PURE__*/_jsx(UISelect, {
      clearable: true,
      "data-test-id": "channel-filter",
      isLoading: loadingGenericChannels,
      onChange: onChange,
      options: genericChannels ? genericChannels.map(buildOption).toArray() : [],
      placeholder: placeholder,
      value: genericChannel && genericChannel[0]
    })
  });
};
ChannelFilter.displayName = 'ChannelFilter';
export default ChannelFilter;